import React from 'react'
import { Helmet } from 'react-helmet-async'

import Logo from '../../assets/images/logo/neovera-banner.png'
// import Fb from '../../assets/images/footer/fb.png'
// import Insta from '../../assets/images/footer/insta.png'
// import Youtube from '../../assets/images/footer/youtube.png'

import { ReactComponent as Location } from '../../assets/images/svg/location.svg'
import { ReactComponent as Email } from '../../assets/images/svg/email.svg'
import { ReactComponent as Icon } from '../../assets/images/svg/contact.svg'

const Footer = () => {
  return (
    <div className='Footer'>
      <Helmet>
        <title>NEOVERA SURVEYING CORPORATION | Measured by Accuracy, Driven by Integrity</title>
        <meta
          name="description"
          content="NEOVERA SURVEYING CORPORATION ensures accuracy, reliability, and professionalism in mineral ore surveying and inspection services worldwide."
        />
        <link rel="canonical" href="https://neoveracsc.com/#footer" />
      </Helmet>

      <div className='Footer__container'>
        <div className='Footer__item'>
          <img src={Logo} alt="NEOVERA SURVEYING CORPORATION banner logo" />
        </div>
        <div className='Footer__item'>
          <h5>ABOUT US </h5>
          <p>
            <Location />NEOVERA SURVEYING CORPORATION: 32 Hulo St., Iba Meycauayan Bulacan, Philippines
          </p>
          <p>
            <Email /> PHILIPPINES@NEOVERACSC.COM
          </p>
        </div>
        <div className='Footer__item'>
          <h5>CONTACT NUMBERS </h5>
          <p>
            <Icon /> 00632 86310308 / 82345739
          </p>
        </div>
      </div>
      <div className='Footer__copyright'>
        <p>Copyright © {(new Date().getFullYear())}. All rights reserved.</p>
      </div>
    </div>
  )
}

export default Footer
